export enum ProxyAction {
    Enable,
    Disable,
    DeleteProxy,
    // DeleteCookies,
    // DeleteAllCookies,
    DeleteAllProxies,
    ShuffleProxies
}